<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="traceToken !== null ? $t('edit_trace_token') : ''"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="$refs.editTraceToken.resetFields()">
    <el-form v-if="traceToken.hasOwnProperty('plan')"
      label-position="top"
      :model="form"
      ref="editTraceToken"
      :disabled="loading">
        <el-form-item
          prop="campaign"
          :label="$t('campaign_name')">
          <el-input v-model="form.campaign" class="ltr text-right"/>
        </el-form-item >
        <el-form-item :label="$t('plan')" prop="plan.id">
          <el-select
            v-model="form.plan.id"
            :placeholder="$t('select')" filterable >
            <el-option
              v-for="plan in plans"
              :key="plan.id.numberStr"
              :label="plan.name"
              :value="plan.id.numberStr">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="`${$t('plan_expiration')} (${$t('day')})`"
          prop="plan.expiration">
          <el-input-number v-model="form.plan_remaining" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item
          prop="expiry"
          :label="`${$t('token_expiration')} (${$t('day')})`">
          <el-input-number v-model="form.expiry" :min="1"></el-input-number>
        </el-form-item >
      <div class="line"></div>
      <el-form-item class="no-margin">
        <el-button
         @click="validateAndSubmitForm('editTraceToken', updateTraceToken)"
         :loading="loading" type="primary">
          {{ $t('submit') }}
        </el-button>
        <el-button
         @click="$emit('close-clicked')"
         :loading="loading">
          {{ $t('close') }}
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    traceToken: {
      type: Object,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      form: {
        campaign: '',
        plan_remaining: '',
        plan: {
          id: ''
        },
        expiry: '',
        id: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'plans'
    ])
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    toggleLoading () {
      this.loading = !this.loading
    },
    handleUpdateTraceTokenSuccess (traceToken) {
      this.$emit('trace-token-updated', traceToken)
      this.displaySuccessMsg('edit_trace_token')
      this.toggleLoading()
      this.handleClose()
    },
    updateTraceToken () {
      const { form } = this
      const { campaign, expiry, plan } = form
      const toUpdate = {
        campaign: campaign,
        plan_remaining: this.convertDaysToSeconds(form.plan_remaining),
        plan_id: plan.id,
        expiry: this.convertDaysToSeconds(expiry)
      }
      this.toggleLoading()
      this.handleRequest({
        name: `trace_tokens/${form.id.numberStr}`,
        action: 'update',
        data: {
          toUpdate
        }
      }).then(this.handleUpdateTraceTokenSuccess)
        .catch(this.toggleLoading)
    },
    setEditTraceTokenForm () {
      const { traceToken, form } = this
      this.loading = false
      form['id'] = traceToken.id
      form['campaign'] = traceToken.campaign
      form['expiry'] = this.convertSecondsToDays(traceToken.expiry)
      form['plan'].id = traceToken.plan.id.numberStr
      form['plan_remaining'] = this.convertSecondsToDays(traceToken.plan_remaining)
    }
  },
  watch: {
    traceToken () {
      this.setEditTraceTokenForm()
    }
  }
}
</script>
